import { Box } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import Trending from "../../shared/Trending";
import {
  TrendingProfessionalsIcon,
  TrendingTalentsIcon,
  TrendingEntitiesIcon,
} from "../../assets/icons/MUI/NetworkIcons";
import { getTrendingProfessionals, getTrendingTalents, getTrendingEntities } from "../../api/network";

const TrendingCol = () => {
  const { t } = useTranslation();

  const {
    data: trendingTalents,
    isLoading: isTrendingTalentsLoading,
    isError: isTrendingTalentsError,
  } = useQuery({
    queryKey: ["trendingTalents"],
    queryFn: async () => await getTrendingTalents(),
  });

  const {
    data: trendingProfessionals,
    isLoading: isTrendingProfessionalsLoading,
    isError: isTrendingProfessionalsError,
  } = useQuery({
    queryKey: ["trendingProfessionals"],
    queryFn: async () => await getTrendingProfessionals(),
  });

  const {
    data: trendingEntities,
    isLoading: isTrendingEntitiesLoading,
    isError: isTrendingEntitiesError,
  } = useQuery({
    queryKey: ["trendingEntities"],
    queryFn: async () => await getTrendingEntities(),
  });

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "14px" }}>
      {!isTrendingTalentsError && (
        <Trending
          icon={<TrendingTalentsIcon />}
          label={t("components.trending.talents")}
          users={trendingTalents}
          isLoading={isTrendingTalentsLoading}
          query="talents"
          sum={true}
        />
      )}
      {!isTrendingProfessionalsError && (
        <Trending
          icon={<TrendingProfessionalsIcon />}
          label={t("components.trending.professionals")}
          users={trendingProfessionals}
          isLoading={isTrendingProfessionalsLoading}
          query="professionals"
        />
      )}
      {!isTrendingEntitiesError && (
        <Trending
          icon={<TrendingEntitiesIcon />}
          label={t("components.trending.entities")}
          users={trendingEntities}
          isLoading={isTrendingEntitiesLoading}
          query="entities"
          sum={true}
        />
      )}
    </Box>
  );
};

export default TrendingCol;
